<template>
  <div class="generalEstimate">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Brief_Report') }}
    </div>
    <div class="generalEstimate-con">
      <!-- <div> -->
      <a-form>
        <!-- <a-form-item
          label="总体结论"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-radio-group v-model="details.ireportConclusion">
            <a-radio value="1">通过</a-radio>
            <a-radio value="2">待定</a-radio>
            <a-radio value="3">不通过</a-radio>
          </a-radio-group>
        </a-form-item> -->
        <!-- <a-form-item
          label="检验标准"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-input v-model="dataForm.biao"></a-input>
        </a-form-item> -->
        <a-form-item
          :label="$tc('lang.ReportsDetail.Brief_Findings')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Loading_Quantity1')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="supervisionDetails.lreoprtIsload">
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtLoad"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Packing_Information1')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="supervisionDetails.lreoprtIspack">
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtPack"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Product_Details1')
            }}</span>
            <span class="span2">
              <a-radio-group
                v-model="supervisionDetails.lreoprtIsproductdetail"
              >
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtProductdetail"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Truck_And_Container1')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="supervisionDetails.lreoprtIstruck">
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtTruck"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Loading_And_Stuffing')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="supervisionDetails.lreoprtIsprocess">
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtProcess"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.LoadingReport.Container_Sealing')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="supervisionDetails.lreoprtIsseal">
                <a-radio value="1">{{
                  $tc('lang.LoadingReport.Conform')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.LoadingReport.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.LoadingReport.Not_Conform')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="supervisionDetails.lreoprtSeal"
              ></a-input>
            </span>
          </div>
        </a-form-item>
        <a-form-item
          :label="$tc('lang.LoadingReport.Remark')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-textarea
            v-model="supervisionDetails.lreportRemark"
            style="resize: none; height: 100px;"
            :placeholder="$tc('lang.ReportsDetail.Description')"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      supervisionDetails: JSON.parse(
        JSON.stringify(this.$store.state.report.supervisionDetails),
      ),
      id: this.$route.query.id,
    };
  },
  computed: {
    data: {
      get() {
        return this.$store.state.report.supervisionDetails;
      },
      set(val) {
        this.$store.commit('report/save', { supervisionDetails: val });
      },
    },
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-loadigreport/getData', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.data = data;
          } else {
            this.data = {};
          }
        })
        .catch(() => {
          this.data = {};
        });
    },
  },
};
</script>
<style lang="less">
.generalEstimate {
  .generalEstimate-con {
    display: flex;
    form {
      flex-grow: 1;
      .ant-form-item-label {
        text-align: left;
        padding-left: 20px;
      }
      .spanGroup {
        display: flex;
        .span1 {
          width: 130px;
        }
        .span2 {
          margin: 0 40px;
        }
        .span3 {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
